import { ITheme, Themes, ThemesName } from "baseStyles/ThemeProvider/themes";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { ThemePallete } from "./themePallete";

interface IThemeProviderState {
    theme: ITheme;
    themeName: ThemesName;
};

const ThemeProviderContext = React.createContext({theme: Themes[ThemesName.default], themeName: ThemesName.default});

const SuiThemeProvider = ({ children, themeName }: any) => {
    const [currentTheme, setThemeName] = useState<ThemesName>(ThemesName.default);
    const [customTheme, setCustomTheme] = useState<ITheme>(null);

    useEffect(() => {
        if(Themes[themeName as ThemesName]) {
            setCustomTheme(null);
            setThemeName(themeName);
        }
    }, [themeName]);

    const theme = useMemo(() => customTheme || Themes[currentTheme], [currentTheme, customTheme]);
    
    const ThemeProviderState: IThemeProviderState = {
        theme,
        themeName: currentTheme
    };
    
    return (
        <>
            <ThemeProviderContext.Provider value={ThemeProviderState}>
                { children } 
            </ThemeProviderContext.Provider>
            <ThemePallete setCustomTheme={setCustomTheme} setThemeName={setThemeName}/>
        </>
    );
}

export const useSuiTheme = () => {
    const context = useContext(ThemeProviderContext);
    if (!context.theme) {
        // throw Error(`Use ${useThemeProviderState.name} in ${ThemeProviderContext.displayName}`);
        console.warn(`Use ${useSuiTheme.name} in ${ThemeProviderContext.displayName}`);
    }
    return context;
};

export default SuiThemeProvider;